/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import rgba from "assets/theme/functions/rgba";
import { getUserAccessLevel } from "helper/user";

function DataTableBodyCell({
  noBorder = false,
  align = "left",
  user_role = "viewer",
  children }) {
  const { light } = colors;
  const { size, fontFamily } = typography;
  const { borderWidth } = borders;

  var priority_colour = rgba("#FFFFFF", 1);

  if (!children.props.row.original.active && getUserAccessLevel(user_role, 'technician')) {
    priority_colour = `linear-gradient(${rgba("#FFFFFF", 0.1)}, ${rgba("#555555", 0.2)})`;
  }
  else {
    if (children.props.row.original.connectivity == 'offline') {
      priority_colour = `linear-gradient(${rgba("#FFFFFF", 0.1)}, ${rgba("#FF0000", 0.1)})`;
    }
    else if (children.props.row.original.battery <= 20 && getUserAccessLevel(user_role, 'technician')) {
      priority_colour = `linear-gradient(${rgba("#FFFFFF", 0.1)}, ${rgba("#EDAA00", 0.2)})`;
    }
  }

  // console.log(children)

  return (
    <SoftBox
      component="td"
      textAlign={align}
      fontSize={size.sm}
      borderBottom={noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`}
      py={1.5}
      px={3}
      sx={{ backgroundImage: priority_colour }}
    >
      {(children.props.row.original.humidity > 55 && children.props.cell.column.id == 'humidity' && getUserAccessLevel(user_role, 'technician')) ? (
        <SoftBox
          display="inline-block"
          width="max-content"
          color="#0766ba"
          sx={{ fontWeight: 'bold', fontFamily: fontFamily, verticalAlign: "middle" }}
        >
          {children}
        </SoftBox>
      ) : (
        <SoftBox
          display="inline-block"
          width="max-content"
          color="text"
          sx={{ fontFamily: fontFamily, verticalAlign: "middle" }}
        >
          {children}
        </SoftBox>
      )}

    </SoftBox>
  );
}

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  user_role: PropTypes.string
};

export default DataTableBodyCell;
